import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'

import BasePopup from '@/components/ui/BasePopup.vue'
import { AnnotationView } from '@/models/doc'


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteHighlightPopup',
  emits: ["confirmDelete"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const highlight = ref<AnnotationView | undefined>(undefined)

function show(_highlight: AnnotationView): void {
  highlight.value = _highlight
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

function confirmDeletion(): void {
  emit('confirmDelete', highlight.value as AnnotationView)
  hide()
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: "Delete Highlight",
    class: "popup--simple"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("p", null, "Are you sure you want to delete this highlight?", -1)),
        _createElementVNode("div", { class: "cancel-form__group--submit" }, [
          _createElementVNode("button", {
            class: "cancel-form__close-btn btns btns--largest btns--font-large btns--full",
            onClick: hide
          }, " Cancel "),
          _createElementVNode("button", {
            class: "cancel-form__btn btns btns--largest btns--font-large btns--red btns--full",
            onClick: confirmDeletion
          }, " Delete ")
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})